import React from "react";
import FeatureItem from "./FeatureItem"; // Upar wala component import karein

const SampleAccountability = ({
  title = "Complete Sample Accountability",
  features = [],
  imageSrc = "/images/BiostorageImg/AccountabilityImg.png",
  discription = "",
}) => {
  return (
    <section className="flex flex-col md:flex-row min-h-[600px] w-full font-sans">
      {/* Left Content Column */}
      <div className="w-full md:w-[55%] bg-[#1a3673] p-8 2xl:p-16 flex flex-col justify-center">
        <div className="mb-10">
          <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-white  tracking-tight">
            {title}
          </h2>
          <p className="text-[14px] md:text-[18px] xl:text-[24px] text-white">
            {discription}
          </p>
        </div>
        <div className="space-y-8">
          {features.map((feature, index) => (
            <FeatureItem
              key={index}
              icon={feature.icon} // Lucide Icon component pass ho raha hai
              title={feature.title}
              description={feature.description}
              isLast={index === features.length - 1}
            />
          ))}
        </div>
      </div>

      {/* Right Image Column */}
      <div className="w-full md:w-[45%] min-h-[300px] md:min-h-full relative overflow-hidden">
        <img
          src={imageSrc}
          alt={title}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-pink-500/20 mix-blend-overlay" />
      </div>
    </section>
  );
};

export default SampleAccountability;
